export const customTheme = {
  palette: {
    primary: {
      main: "rgb(167, 175, 124)",
      contrastText: "#000"
    },
    secondary: {
      main: "rgb(245, 248, 228)",
      contrastText: "#636363"
    }
  }
};
